import { CloseAdminPanelButton } from './CloseAdminPanelButton';
export const AdminPanelHeader = ({ onClose, title }) => (<div className='admin-panel__form-header'>
    <div className='workspace-header__title workspace-header__block'>{title}</div>
    <CloseAdminPanelButton onClick={onClose}/>
  </div>);
